import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "../../app/store"
import { Payload } from "../../components/Booking/postInterFace"
import { number } from "yup"

interface PostCreateState {
  bookingDetails: Payload
  // Service chosen on the landing page ("Book Now"), pre-selected on the
  // service-selection screen. Kept in the store so it survives the auth
  // redirect (which strips the URL query string) after login.
  pendingService: string
}

const initialState: PostCreateState = {
  pendingService: "",
  bookingDetails: {
    location: "",
    service: "",
    ageRange: "",
    from: "",
    till: "",
    description: "",
    personRequired: "",
    language: [],
    attachment: [],
    extraDetails: {} as Record<string, unknown>,
    hours: 0,
    postPrice: undefined,
    stripepricekey: [],
    timeUpdate: "",
    updateEndTime: "",
    serviceName: "",
    tax: 0,
  },
}

const slice = createSlice({
  name: "postCreate",
  initialState,
  reducers: {
    setBookingDetails: (state, action) => {
      state.bookingDetails = action.payload
    },
    setPendingService: (state, action) => {
      state.pendingService = action.payload
    },
  },
})

export const { setBookingDetails, setPendingService } = slice.actions

export const selectBookingDetails = (state: RootState) =>
  state.postCreate.bookingDetails

export const selectPendingService = (state: RootState) =>
  state.postCreate.pendingService

export default slice.reducer
